<template>
    <div>
        <div class='contents'>
            <section class="hero is-light is-fullheight">
                <div class="hero-body">
                    <div class="container">
                        <div class="columns is-centered">
                            <div class="column is-5-tablet is-4-desktop is-4-widescreen">
                                <form action="" class="box">
                                    <div class="field">
                                        <label for="" class="label">登録済みのメールアドレス</label>
                                        <div class="control has-icons-left">
                                            <input v-model='email' type="email" class="input" required>
                                            <span class='icon is-small is-left'>
                                                <i class='fas fa-envelope'></i>
                                            </span>
                                        </div>
                                    </div>
                                    <router-link to="/login"><p class='link'>ログインページへ戻る</p></router-link>
                                    <div class="field">
                                        <div class="button is-success submit" @click='submit'>
                                            送信
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>

export default {
    name: 'Forgot',
    components: {
    },
    data () {
        return {
            email: ''
        }
    },
    mounted () {
    },
    methods: {
        submit () {
            const self = this
            self.axios.post(`${process.env.API_URL}/forgot`, {
                email: self.email
            }).then((res) => {
                if (res.data.message === 'Failed') {
                    self.$root.$emit('notification', 'is-danger', '入力されたメールアドレスは登録されていません')
                    return
                }

                self.$root.$emit('notification', 'is-primary', '入力されたメールアドレスへ復旧用メールを送信しました')
            }).catch((e) => {
                self.$root.$emit('notification', 'is-danger', 'サーバーに問題が発生しています')
            })
        }
    }
}
</script>

<style scoped>
.submit {
    margin-top: 30px;
    width: 100%;
}

.link {
    color: #1a0dab;
}
</style>



// WEBPACK FOOTER //
// src/routes/Forgot.vue